import { Position } from "@xyflow/react";
import { NODE_REGISTRY } from "components/CC/Nodes/node-config";
import { BaseNodeProps } from "components/CC/Nodes/node-types";
import { BaseNode } from "components/CC/Nodes/NodeBase/BaseNode";
import {
    InstantBadge,
    PingBadge,
    PostBadge,
    PostVerifyBadge,
    StartIcon,
    WebhookBadge,
} from "components/CC/Nodes/NodeIcons";
import { NodeType, StartFlowType } from "components/CC/types/enums";
import { TransparentHandle } from "components/CC/UI/TransparentHandle";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { ReactNode } from "react";

const FLOW_BADGE_MAP: Record<StartFlowType, ReactNode> = {
    post: <PostBadge />,
    ping: <PingBadge />,
    postVerify: <PostVerifyBadge />,
    webhook: <WebhookBadge />,
    instant: <InstantBadge />,
};

export const StartNode = ({ id, data }: BaseNodeProps) => {
    const { t } = usePaldockTranslation("components.connection-creator");
    const formData = data?.formData as { flow?: StartFlowType } | undefined;
    const flow = formData?.flow;
    const badge = flow ? FLOW_BADGE_MAP[flow] : undefined;

    return (
        <div>
            <BaseNode
                id={id}
                data={data}
                color={NODE_REGISTRY[NodeType.Start].color}
                label={t("nodes.start.title")}
                badge={badge}
            >
                <StartIcon />
            </BaseNode>
            <TransparentHandle position={Position.Right} type="source" />
        </div>
    );
};
